export enum TagEnum {
  CYPHER = "CYPHER",
  IMAGE = "IMAGE",
  OSINT = "OSINT",
  QUIZZ = "QUIZZ",
  SOFTWARE = "SOFTWARE",
  SQL = "SQL",
  WEB = "WEB",
  IA = "IA",
  HISTORY = "HISTORY",
  CLOUD = "CLOUD"
}
